export const QuestionType = {
  SingleChoice: "single_choice",
  Open: "open",
};

export const OpenQuestionMaxLength = 500;
